import * as React from "react";
import ContentPanel from "./contentPanel";
import "./index.less";

interface IMultiTag {
  data: any;
  returnCheckedOption: any;
  // 一行显示的项的数目
  optionSize?: any;
  // 占位提示信息
  placehorder?: any;
  value?: any;
  onRef?: any;
  // 用于找到父节点的选择器
  containerBody?: any;
}

// 多选Tag
class MultilTag extends React.Component<IMultiTag, any> {
  state = {
    visible: false,
    checkedList: [],
    // 内容对象的引用
    contentCurrent: null
  };

  constructor(props: IMultiTag) {
    super(props);
    this.props.onRef && this.props.onRef(this);
  }

  // 更新面板状态
  updateVisible = visible => {
    this.setState({
      visible
    });
  };

  // 更新选中的项
  updateCheckedOption = data => {
    this.setState(
      {
        checkedList: data && data
      },
      () => {
        this.props.returnCheckedOption(this.state.checkedList);
      }
    );
  };

  // 获取内容对象的引用
  getContentPanelRef = contentCurrent => {
    this.setState({
      contentCurrent
    });
  };

  // 清除标签
  clear = () => {
    const contentCurrent: any = this.state.contentCurrent;
    if (contentCurrent) {
      contentCurrent.clear();
    }
  };

  // 控制下拉多选框的样式
  controlMultiClass = () => {
    return "multi-tag " + (this.state.visible ? "multi-tag-open" : "");
  };

  render() {
    return (
      <div className={this.controlMultiClass()}>
        <ContentPanel
          data={this.props.data}
          value={this.props.value}
          retrunVisible={this.updateVisible}
          returnCheckedOpiton={this.updateCheckedOption}
          optionSize={this.props.optionSize}
          tagSize={10000}
          placehorder={this.props.placehorder}
          onRef={this.getContentPanelRef}
          containerBody={this.props.containerBody}
        />
      </div>
    );
  }
}

export default MultilTag;
